module.exports = __webpack_public_path__ + "img/21600.eaf523c1.jpg";